module.exports = __webpack_public_path__ + "img/pic6.22d71e39.png";